var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastCash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 50C11.6929 50 0.5 38.8071 0.5 25C0.5 11.1929 11.6929 0 25.5 0C39.3071 0 50.5 11.1929 50.5 25C50.5 38.8071 39.3071 50 25.5 50Z",
    fill: "#27490F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23C15.9477 23 15.5 22.5523 15.5 22V17C15.5 16.4477 15.9477 16 16.5 16H21.5C22.0523 16 22.5 16.4477 22.5 17V22C22.5 22.5523 22.0523 23 21.5 23H16.5Z",
    fill: "#27490F",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 35C15.9477 35 15.5 34.5523 15.5 34V29C15.5 28.4477 15.9477 28 16.5 28H21.5C22.0523 28 22.5 28.4477 22.5 29V34C22.5 34.5523 22.0523 35 21.5 35H16.5Z",
    fill: "#27490F",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 35C28.9477 35 28.5 34.5523 28.5 34V29C28.5 28.4477 28.9477 28 29.5 28H34.5C35.0523 28 35.5 28.4477 35.5 29V34C35.5 34.5523 35.0523 35 34.5 35H29.5Z",
    fill: "#27490F",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9021 15.6945V23.2958",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1036 19.4976H35.7048",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastCash);
export default __webpack_public_path__ + "static/media/fast-cash.758c5de1cfd9f2e1dcb96af7e09bd582.svg";
export { ForwardRef as ReactComponent };